import { _ as __read } from '../../../../_tslib-7a01aab4.js';
import React, { useState, useCallback, useEffect } from 'react';

var OverlayFooter = function (_a) {
    var title = _a.title, activeOverlay = _a.activeOverlay, children = _a.children;
    var _b = __read(useState(null), 2), isOpen = _b[0], setIsOpen = _b[1];
    var handleToggle = useCallback(function () {
        setIsOpen(function (prev) { return !prev; });
    }, [setIsOpen]);
    useEffect(function () {
        setIsOpen(null);
    }, [activeOverlay]);
    return (React.createElement("div", { className: "pgc-limits-payouts-results-bottom ".concat(isOpen ? 'show-last-cards' : isOpen === false ? 'hide-last-cards' : '') },
        React.createElement("div", { className: 'pgc-limits-payouts-results-bottom-inner-wr' },
            React.createElement("div", { className: 'pgc-limits-payouts-results-bottom-inner-wr-top' },
                React.createElement("div", { className: 'pgc-last-card-shower', onClick: handleToggle },
                    React.createElement("p", { className: 'pgc-last-card-shower-txt' }, title),
                    React.createElement("div", { className: 'pgc-last-card-shower-icon-block' },
                        React.createElement("i", { className: 'icon-arrow-down' })))),
            React.createElement("div", { className: 'pgc-limits-payouts-results-bottom-inner-wr-bottom' }, children))));
};

export { OverlayFooter };
